import { Tabs, useLocalSearchParams } from "expo-router";
import { Platform, View } from "react-native";
import { HapticTab } from "@/components/HapticTab";
import TabBarBackground from "@/components/ui/TabBarBackground";
import { useTheme } from "@/hooks/useTheme";
import { MaterialIcons } from "@expo/vector-icons";

export default function ShiftClockInLayout() {
  const { colors } = useTheme();
  const { shift } = useLocalSearchParams();

  return (
    <Tabs
      layout={({ children }) => (
        <View
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              flex: 1,
              width: "100%",
              maxWidth: 800,
            }}
          >
            {children}
          </View>
        </View>
      )}
      screenOptions={{
        animation: "shift",
        tabBarHideOnKeyboard: true,
        sceneStyle: {
          backgroundColor: colors.backgroundSecondary,
          borderColor: colors.border,
        },
        tabBarLabelPosition: Platform.select({
          default: "below-icon",
        }),
        tabBarLabelStyle: Platform.select({
          default: { color: colors.text, fontSize: 12 },
        }),
        tabBarActiveBackgroundColor: colors.primary,
        tabBarActiveTintColor: "white",
        headerShown: false,
        headerShadowVisible: false,
        tabBarButton: HapticTab,
        tabBarBackground: TabBarBackground,
        tabBarStyle: { display: "none" },
      }}
    >
      <Tabs.Screen
        name="index"
        options={{
          title: "Clock In",
          animation: "shift",
          tabBarIcon: ({ color }: any) => <MaterialIcons name="email" size={24} color={color} />,
        }}
      />
      <Tabs.Screen
        name="confirm"
        options={{
          title: "Confirm",
          animation: "shift",
          tabBarIcon: ({ color }: any) => <MaterialIcons name="check-circle" size={24} color={color} />,
        }}
      />
    </Tabs>
  );
}
